// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__22Wc-","inputWrap":"styles_inputWrap__2x-3j","input":"styles_input__2ws0c"};